export const databasesLinksMap = {
  'Reaxys Medicinal Chemistry': 'MedChem', // If can't find database link by name, use that map
};
export const CI_DATABASES = ['9', '10', '11', '12', '13', '14', '19'];
export const SUPPLIER_DATABASE_IDS = ['5', '15', '16', '18'];
export const RCS_DATABASES = ['20'];
export const PU_DATABASES = ['1'];
